import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { deletePlacementWorksheetUnitOccupant } from "../../services/PlacementWorksheetApi";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Modal } from "../Modal";
import { usePlacementWorksheetTableRowContext } from "../PlacementWorksheetTable/PlacementWorksheetTableRowContext";

interface IProps {
  unitId: number;
  onSuccess?: VoidFunction;
  residentId?: string;
}

export const UnmatchModal: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { setIsOpen } = useModalContext();
  const [isUnitRemoveLoading, setIsUnitRemoveLoading] = React.useState(false);
  const { l2Id, l3Id, removeOccupantFromUnit } = usePlacementWorksheetContext();
  const { setIsFinished } = usePlacementWorksheetTableRowContext();

  const closeModal = () => setIsOpen(false);

  const handleUnitRemove = async () => {
    if (!l2Id || !l3Id || !props.residentId) return;

    setIsUnitRemoveLoading(true);

    await deletePlacementWorksheetUnitOccupant(
      selectedNetworkId,
      l2Id,
      l3Id,
      props.unitId,
      props.residentId,
      await getAuthToken()
    )
      .then((res: any) => {
        if (res.error) {
          showErrorSnackbar(res.error.description);
        }

        if (!props.residentId) return;

        removeOccupantFromUnit(props.unitId, props.residentId);

        setIsFinished(true);

        if (props.onSuccess) {
          props.onSuccess();
        }
      })
      .catch(() => showErrorSnackbar())
      .finally(() => setIsUnitRemoveLoading(false));
  };

  return (
    <Modal
      maxWidth="sm"
      onClose={closeModal}
      title="Are you sure?"
      actions={
        <>
          <Button appearance="subtle" onClick={closeModal} isDisabled={isUnitRemoveLoading}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={handleUnitRemove} isLoading={isUnitRemoveLoading}>
            Unmatch and return to Unplaced
          </Button>
        </>
      }
    >
      <Box p={3}>
        <Typography>
          If this resident is matched with any roommates, they will be removed from the match and returned to the right
          hand column.
        </Typography>
      </Box>
    </Modal>
  );
};
